import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'order-list-mobile',
    templateUrl: './list-mobile.component.html',
    styleUrls: ['./list-mobile.component.scss'],
    standalone: false
})
export class ListMobileComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
